'use client';
import { useEffect } from 'react';

import { Logger } from '@/lib/Logging';
import { useTranslation } from '@/lib/i18n/i18n.client';

import ErrorPageContent from '@/app/ErrorFile';

const logger = new Logger('src/app/error.tsx handler');
// Error components must be Client Components

export default function Error({
  error,
}: {
  error: Error & { digest?: string };
}) {
  const { texts } = useTranslation();

  useEffect(() => {
    logger.error(error);
  }, [error]);

  return <ErrorPageContent message={texts.error_page.something_went_wrong} />;
}
